import { render } from "./MdBadge.vue?vue&type=template&id=42c79fb8&scoped=true&ts=true"
import script from "./MdBadge.vue?vue&type=script&lang=ts"
export * from "./MdBadge.vue?vue&type=script&lang=ts"

import "./MdBadge.vue?vue&type=style&index=0&id=42c79fb8&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c79fb8"]])

export default __exports__